var React = require('react');

function ArrowRotated (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Frame 89"},React.createElement("path",{"id":"Vector 1","d":"M4.16962 11.3303L11.8299 3.66994M11.8299 3.66994L5.34813 3.66994M11.8299 3.66994L11.8299 10.1518","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"})));
}

ArrowRotated.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = ArrowRotated;

ArrowRotated.default = ArrowRotated;
